<script lang="ts">
	import Button from '$lib/buttons/v3/button.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{ title: string; link: SbLink }>['content'];
		btnClasses?: string;
	}

	let { content, btnClasses = 'btn-brown' }: Props = $props();
</script>

<li use:editable={content}>
	<Button
		class={['btn-tertiary', btnClasses]}
		href={getSbUrl(content.link)}
		target={content.link.target}>{content.title}</Button
	>
</li>
